<template>
    <slot :childScope="childScope" :childMethods="{showPasswordForm, togglePasswordReveal}"/>
</template>
<script>
export default {
    props: ['min', 'regex', 'errors', 'modelValue'],
    emits: ['update:modelValue'],
    data() {
        return {
            childScope: {
                password: '',
                revealPassword: false,
                rules: {
                    passwordLength: false,
                    // regex rules added dynamically on created()
                },
                passwordFormVisible: false,
            }
        }
    },
    watch: {
        modelValue(val) {
            this.childScope.password = val;
        },
        'childScope.password': function (current) {
            this.$emit('update:modelValue', current);
            _.forEach(this.regex, (value, key) => {
                this.childScope.rules[_.camelCase(value)] = new RegExp(key).test(current)
            });
            this.childScope.rules.passwordLength = current.length >= this.min
        }
    },
    created() {
        _.forEach(this.regex, (value, key) => {
            this.childScope.rules[_.camelCase(value)] = false;
        });
        this.childScope.passwordFormVisible = this.errors; // if we have errors, make it visible
    },
    methods: {
        showPasswordForm() {
            this.childScope.passwordFormVisible = true;
        },
        togglePasswordReveal() {
            this.childScope.revealPassword = !this.childScope.revealPassword
        }
    }
}
</script>
